export const environment = {
  production: true
};

export const config = {
  'QueryServerUrl': 'https://fla.efinancial.com/api/query/GetPolicyInfo?policyHash=',
  'BrandInfoUrl': 'https://pozb4ibnua.execute-api.us-east-1.amazonaws.com/prod/source/',
  'ThankYouUrl': 'https://fla.efinancial.com/thankyou?source=',
  'PolicyUpdateUrl':'https://fla.efinancial.com/api/PolicyUpdate/PostPolicyInfo',
};
